import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";

class ReadyForDeliveryStore extends EventEmitter {
    constructor() {
        super();
        this.allOrders=[];
        this.filteredOrders=[];
    }
    getAll() {
        return this.allOrders;
    }
    getSingle(id) {

    }
    getFiltered(){
        return this.filteredOrders;
    }

    handleActions(action) {
        switch (action.type) {
            case "RECEIVE_ALL_READY_FOR_DELIVERY_ORDERS":
            {
                this.filteredOrders=action.readyOrders;
                this.allOrders=action.readyOrders;
                this.emit("change");
                break
            }
            case "FILTER_DATA_BY_DATES":{
                this.emit("change");
                break;
            }
        }



    }

}

const readyForDelivery = new ReadyForDeliveryStore;
dispatcher.register(readyForDelivery.handleActions.bind(readyForDelivery));

export default readyForDelivery;



// WEBPACK FOOTER //
// ./src/stores/ReadyForDeliveryOrdersStore.js